import React from 'react';
import { trainers } from '../data/mockData';

const Trainers = () => {
  return (
    <section id="trainers" className="section-padding bg-card relative z-10">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="heading-2 mb-6">הצוות שלנו</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto">
            אנשי מקצוע מעולים המתמחים בתחומים וסוגי ספורט שונים
          </p>
        </div>

        {/* Trainers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trainers.map((trainer, index) => (
            <div 
              key={trainer.id}
              className="team-card scroll-reveal-scale"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Image - Fixed aspect ratio */}
              <div className="team-card-image-fixed">
                <img 
                  src={trainer.image}
                  alt={trainer.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content - Larger height */}
              <div className="team-card-content-expanded">
                <h3 className="heading-4 mb-3 text-primary">
                  {trainer.name}
                </h3>
                <p className="caption text-wood-light mb-4">
                  {trainer.specialty}
                </p>
                <p className="body-small text-secondary mb-4 leading-relaxed">
                  {trainer.title}
                </p>
                <p className="body-small text-muted leading-relaxed">
                  {trainer.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trainers;
